/**
 * Rounds a given floating number to the given amount of digits.
 * Default amount of digits equals 2
 *
 * @param value
 * @param fractionDigits
 * @returns
 */
export const roundFloatingNumber = (value: number, fractionDigits = 2): number =>
    Number(value.toFixed(fractionDigits));
